// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react'
import ReactDOM from 'react-dom'
import App from '../quiz/App'

const root = document.getElementById('quiz')
const field = root.nextElementSibling.textContent

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<App field={field} />, root)
})
